export default __webpack_public_path__ + "static/media/20ff.6ebe8a8f.png";